import React, { useState, useEffect } from "react";
import "./MainView.css";
import {
    Add,
    CalendarMonth,
    Cancel,
    Check,
    Edit,
    FilterAlt,
    FormatListBulleted,
    KeyboardArrowDown,
} from "@mui/icons-material";
import FilterSelect from "./FilterSelect";
import CalendarView from "../Calendar/Calendar";
import {
    Alert,
    AppBar,
    Button,
    Menu,
    Checkbox,
    CircularProgress,
    FormControl,
    IconButton,
    Input,
    MenuItem,
    Select,
    Tooltip,
} from "@mui/material";
import ListView from "../ListView/ListView";
import Loader from "../Common/Loader/Loader";
import { getServiceAliases, getReleaseBasedOnJobs, getServiceMapping, getReleaseBasedServiceComponents, getReleaseBasedDependentServices, getServiceComponents, getDependentServices } from "../../Services";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { createColorCodeForRelease, sourceMapping, vendorDict, eventTypes } from "../../utility";
import UserPreference from "../UserPreference/UserPreference";
import TimelineView from "../TimelineView/TimelineView";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
  } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import { getGroupingOfSources } from "../../utility";

const MainView = ({ preference, mainViewState, mainViewStateLoadString, mainViewStateIsNewUser, isLoading, setLoader }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.replace("/", "") || "calendar";
    const email = sessionStorage.getItem("email")
        ? sessionStorage.getItem("email")
        : null;
    const [isListView, setIsListView] = useState(false);
    const [events, setEvents] = useState([]);
    const [filtererdEvents, setFilteredEvents] = useState([]);
    const quickFilters = preference ? preference["quick_services"] : [];
    const [serviceObj, setServiceObj] = useState(null);
    const [filterServiceObj, setFilterServiceObj] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [selectedTab, setSelectedTab] = useState(path);
    // const [categoryList, setCategoryList] = useState([]);
    const [categoryList, setCategoryList] = useState(['Release', 'Maintenance', 'Outage']);
    const [tierList, setTierList] = useState([]);
    const [impactList, setImpactList] = useState(["N/A", "High", "Medium", "Low"]);
    const [envList, setEnvList] = useState([]);
    const [colorCoding, setColorCoding] = useState(null);
    const [sources, setSources] = useState([]); // 'Enterprise','BFR',
    const [selectedSources, setSelectedSources] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedTier, setSelectedTier] = useState([]);
    const [selectedEnv, setSelectedEnv] = useState([]);
    const [selectedImpact, setSelectedImpact] = useState([]);
    const [selectedQuickFilters, setSelectedQuickFilters] = useState([]);
    const [usedReleaseId, setUsedReleaseId] = useState(null);
    const [aliases, setAliases] = useState({});
    const [serviceComponents, setServiceComponents] = useState({});
    const [dependentServices, setDependentServices] = useState({});
    const [hasServiceComponentReleases, setHasServiceComponentReleases] = useState(false);
    const [hasDependentServiceReleases, setHasDependentServiceReleases] = useState(false);
    const [isNewUser, setNewUser] = useState(false);
    const [isDataLoaded, setDataLoaded] = useState(false);
    const [loadString, setLoadString] = useState('');
    const [isUserPreferenceOpen, setIsUserPreferenceOpen] = useState(false);
    const [openTab, setTab] = useState(null);
    const { releaseId } = useParams();
    const loggedIn = sessionStorage.getItem("isLoggedIn") === 'true' ? true : false;
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    
    const [availableFilters, setAvailableFilters] = useState([
        { label: "Business Service", key: "service", isVisible: true, isMandatory: true },
        { label: "Status", key: "status", isVisible: false, isMandatory: false },
        { label: "Category", key: "category", isVisible: true, isMandatory: true },
        { label: "Environment", key: "environment", isVisible: false, isMandatory: false },
        { label: "Service Tier", key: "tier", isVisible: true, isMandatory: true },
        { label: "Impact", key: "impact", isVisible: false, isMandatory: false },
    ]);
    
    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    useEffect(() => {
        setSelectedTab(path);
    }, [path]);

    const handleFilterToggle = (filter) => {
        if (!filter.isMandatory) {
            setAvailableFilters(prevFilters =>
                prevFilters.map(f =>
                    f.key === filter.key ? { ...f, isVisible: !f.isVisible } : f
                )
            );
    
            setSelectedFilters(prev => {
                const exists = prev.some(f => f.key === filter.key);
                if (exists) {
                    return prev.filter(f => f.key !== filter.key);
                } else {
                    return [...prev, filter];
                }
            });
        }
    };

    useEffect(() => {
        if (!loggedIn && releaseId) {
            sessionStorage.setItem("path", `${releaseId}`);
            sessionStorage.setItem("directLogin", true);
            setLoader(true);
            navigate('/login');
        } else if (loggedIn && releaseId) {
            setUsedReleaseId(releaseId);
            sessionStorage.removeItem("path");
            sessionStorage.removeItem("directLogin");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedIn, releaseId]);

    useEffect(() => {
        if (window.location.pathname === "/") {
            setUsedReleaseId(null);
        }
    });

    useEffect(() => {
        if (!email) {
            console.log("user not found");
            navigate("/login");
        }
    }, []);

    useEffect(() => {
        if (!mainViewState) return;
        const colorCoding = createColorCodeForRelease(mainViewState.events);
        setIsListView(mainViewState.isListView ?? false);

        setAliases(mainViewState.aliases || {});
        setServiceObj(mainViewState.serviceObj || null);
        setServiceComponents(mainViewState.serviceComponents || {});
        setDependentServices(mainViewState.dependentServices || {});

        setSources(mainViewState.sources || []);
        setSelectedSources(mainViewState.sources || []);
        setColorCoding(colorCoding || null);
        setEvents(mainViewState.events || []);
        setFilteredEvents(events);
        setStatusList(mainViewState.statusList || []);
        setEnvList(mainViewState.envList || []);
        setTierList(mainViewState.tierList || []);
        setHasServiceComponentReleases(!!mainViewState.hasServiceComponentReleases);
        setHasDependentServiceReleases(!!mainViewState.hasDependentServiceReleases);

        setDataLoaded(!!mainViewState.isDataLoaded);
        setLoadString(mainViewStateLoadString || "");
        
        setNewUser(!!mainViewStateIsNewUser);
    }, [mainViewState, mainViewStateLoadString, mainViewStateIsNewUser]);

    const toggleView = (bool) => {
        setIsListView(bool);
    };

    const updateEvents = () => {
        let filterList =
          selectedQuickFilters.length > 0 ? filtererdEvents : [...events];
    
        if (selectedSources.length === 0) {
          filterList = [];
        } else if (selectedSources.length > 0) {
          if (selectedSources.length !== sources.length) {
            filterList = filterList.filter((event) => {
              return selectedSources.includes(event["Vendor_type"]);
            });
          }
          if (selectedService.length > 0) {
            filterList = filterServiceWithAllCriteria(selectedService, filterList);
          }
          if (selectedStatus.length > 0) {
            filterList = filterList.filter((event) => {
              return selectedStatus.includes(event["release_status"]);
            });
          }
          if (selectedCategory.length > 0) {
            filterList = filterList.filter((event) => {
              return selectedCategory.includes(event["release_category"]);
            });
          }
          if (selectedEnv.length > 0) {
            filterList = filterList.filter((event) => {
              return selectedEnv.includes(event["environment"]);
            });
          }
        }
        if (selectedTier.length > 0) {
            filterList = filterList.filter((event) => {
                const eventTier = event["tier"] || "N/A";
                return selectedTier.includes(eventTier);
            });
          }
          if (selectedImpact.length > 0) { 
            filterList = filterList.filter((event) => {
                const eventImpact = event["relevance"] || "N/A"; // Assign "N/A" if undefined
                return selectedImpact.includes(eventImpact);
            });
        }
        setFilteredEvents(filterList);
    };
    
    const filterServiceWithAllCriteria = (service, filterList) => {
        let allServicesWithSource = {};
        service.forEach((str) => {
          allServicesWithSource[str.toLowerCase()] = str;
        });

        const addServices = (source, servicesToAdd) => {
          servicesToAdd.forEach((str) => {
            const lowerStr = str.toLowerCase();
            if (!allServicesWithSource[lowerStr]) {
              allServicesWithSource[lowerStr] = source;
            }
          });
        };

        const filterServiceMapper = (lookup) => {
          for (const [key, values] of Object.entries(lookup)) {
            const lowerKey = key.toLowerCase();
            if (allServicesWithSource[lowerKey]) {
              addServices(allServicesWithSource[lowerKey], values);
            }
          }
        };

        filterServiceMapper(aliases);
        filterServiceMapper(serviceComponents);
        filterServiceMapper(dependentServices);

        return filterList.reduce((acc, event) => {
          const lowerVendorService = event["vendor_service"].toLowerCase();
          const matchedService = Object.keys(allServicesWithSource).find((str) =>
            lowerVendorService.includes(str)
          );
          if (matchedService) {
            event["parent_service"] = allServicesWithSource[matchedService];
            acc.push(event);
          }
          return acc;
        }, []);
    };
    const toggleSourceSelection = (event, action = null) => {
        if (action === "selectAll") {
            // Select all sources
            setSelectedSources(sources.map((source) => source));
        } else if (action === "removeAll") {
            // Remove all sources
            setSelectedSources([]);
        }
    };
    

    const handleServiceChange = (event) => {
        const { value } = event.target;
        const allSelected = value.includes("all");
    
        if (allSelected) {
            if (value.length === filterServiceObj.length + 1) {
                setSelectedService([]);
            } else {
                setSelectedService([...filterServiceObj]);
            }
        } else {
            setSelectedService(value.filter(Boolean) || []);
        }
    };
    
    const handleImpactChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedImpact(typeof value === "string" ? value.split(",") : value);
    };

    const handleStatusChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedStatus(typeof value === "string" ? value.split(",") : value);
    };

    const handleCategoryChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedCategory(typeof value === "string" ? value.split(",") : value);
    };

    const handleEnvChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedEnv(typeof value === "string" ? value.split(",") : value);
    };

    const handleTierChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedTier(typeof value === "string" ? value.split(",") : value);
    };

    const addQuickFilters = (service) => {
        setSelectedQuickFilters([...selectedQuickFilters, service]);
    };

    const removeQuickFilters = (event, service) => {
        event.stopPropagation();
        let filter = selectedQuickFilters.filter((s) => s !== service);
        setSelectedQuickFilters(filter);
    };

    const removeSelectedService = () => {
        setSelectedService([]);
    };

    const removeSelectedImpact = () => {
        setSelectedImpact([]);
    };
    const removeSelectedStatus = () => {
        setSelectedStatus([]);
    };

    const removeSelectedCategory = () => {
        setSelectedCategory([]);
    };

    const removeSelectedEnv = () => {
        setSelectedEnv([]);
    };

    const removeSelectedTier = () => {
        setSelectedTier([]);
    };

    useEffect(() => {
        if (isNewUser) {
            setTab(1);
            setIsUserPreferenceOpen(true);
        }
    }, [isNewUser]);

    useEffect(() => {
        if (events.length) {
            updateEvents();
        }
    }, [selectedService, selectedStatus, selectedCategory, selectedEnv, selectedTier, selectedSources, selectedImpact, aliases]);

    useEffect(() => {
        if (events.length) {
            let filterList = events;
            if (selectedSources.length !== sources.length) {
                filterList = filterList.filter((event) => {
                    return selectedSources.includes(event["Vendor_type"]);
                });
            }
            if (selectedQuickFilters.length > 0) {
                filterList = filterServiceWithAllCriteria(selectedQuickFilters, filterList);
            }
            setFilteredEvents(filterList);
        }
    }, [selectedQuickFilters]);
    // to filter services based on selected sources
    useEffect(() => {
        let obj = [];
        if (serviceObj && selectedSources.length === sources.length) {
            obj = Object.keys(serviceObj);
        } else if (serviceObj && selectedSources.length > 0) {
            obj = Object.keys(serviceObj).filter((service) => {
                return selectedSources.some(s => serviceObj[service].includes(s));
            });
        }
        setFilterServiceObj(obj);
        setSelectedService(obj);
    }, [selectedSources, serviceObj]);

    const handleEventDetailsClose = () => {        
        if (isNewUser) {
            setTab(1);
            setIsUserPreferenceOpen(true);
        }
    };

    useEffect(() => {
        if (statusList.length) {
            setSelectedStatus(statusList);
        }
    }, [statusList]);

    useEffect(() => {
        if (envList.length) {
            setSelectedEnv(envList);
        }
    }, [envList]);

    useEffect(() => {
        if (categoryList.length) {
            setSelectedCategory(categoryList);
        }
    }, [categoryList]);

    useEffect(() => {
        if (tierList.length) {
            setSelectedTier(tierList);
        }
    }, [tierList]);

    useEffect(() => {
        if (impactList.length) {
            setSelectedImpact(impactList);
        }
    }, [impactList]);

    const getList = (data, key) => {
        let list = new Set();
        data.forEach((element) => {
            const keyValue = element[key];
            if (keyValue && !list.has(keyValue)) {
                list.add(keyValue);
            }
        });
        return Array.from(list).sort();
    };

    const editQuickFilters = () => {
        setTab(2);
        setIsUserPreferenceOpen(true);
    }

    const handleClosePreference = () => {
        setTab(null);
        setIsUserPreferenceOpen(false);
    };
    const closeAlert = () => {
        setHasDependentServiceReleases(false);
        setHasServiceComponentReleases(false);
    }

    const stopImmediatePropagation = (e) => {
        e.stopPropagation();
    };

    //get grouped sources list
    const sourceGroupsArray = getGroupingOfSources(sources);

    return (
        !isNewUser ? <>
            <div className="d-flex w-100">
                <div style={{ width: '100%' }}>
                    {
                            <>
                            <AppBar
                                position="static"
                                sx={{
                                    backgroundColor: "#000000",
                                    height: "50px",
                                }}
                            >
                                <div className="quick-filters justify-content-between d-flex h-100 px-4">
                                    <div className="d-flex align-items-center pr-4">
                                        <span className="text-light mr-2 font-weight-bolder">QUICK FILTERS: </span>
                                        <ul className="navbar-nav flex-row">
                                            {quickFilters?.map((i) => (
                                                <li className="nav-item" key={i}>
                                                    <Tooltip title={i}>
                                                        <a
                                                            className={`nav-link${selectedQuickFilters.indexOf(i) > -1 ? " active" : ""
                                                                }${isDataLoaded ? "" : " disabled"}`}
                                                            onClick={() => addQuickFilters(i)}
                                                        >
                                                            <span className="chip-text text-truncate">{i}</span>
                                                            {
                                                                selectedQuickFilters.indexOf(i) > -1 &&
                                                                <IconButton
                                                                    className="ml-1"
                                                                    size="small"
                                                                    sx={{ p: 0, color: "#9b9a9a" }}
                                                                    onClick={($event) => removeQuickFilters($event, i)}
                                                                >
                                                                    <Cancel sx={{ fontSize: "16px" }} />
                                                                </IconButton>
                                                            }
                                                        </a>
                                                    </Tooltip>
                                                </li>
                                            ))}
                                        </ul>
                                        <IconButton
                                            sx={{ color: "#888" }}
                                            onClick={editQuickFilters}
                                        >
                                            <Tooltip title={'Edit quick filters'}>
                                                <Edit fontSize="small" />
                                            </Tooltip>
                                        </IconButton>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end">
                                    <FormControl className="source-list" size="small">
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            sx={{ fontSize: "0.9rem" }}
                                            className="font-weight-bolder"
                                            size="small"
                                            disabled={selectedQuickFilters.length > 0 || !isDataLoaded}
                                            endIcon={<KeyboardArrowDown />}
                                        >
                                            Sources{" "}
                                            {`${selectedSources.length > 0
                                                ? " | " +
                                                (selectedSources.length === sources.length
                                                    ? "All"
                                                    : selectedSources.length > 3
                                                    ? selectedSources.slice(0, 3).join(", ") + `, +${selectedSources.length - 3} more`
                                                    : selectedSources.join(", "))
                                                : ""
                                            }`}
                                        </Button>
                                        {isDataLoaded && colorCoding && (
                                            <Select
                                                labelId="source"
                                                id="source"
                                                multiple
                                                value={selectedSources.length === sources.length ? ["all", ...selectedSources] : selectedSources}
                                                className={`${
                                                    selectedQuickFilters.length > 0 || !isDataLoaded ? "disabled" : ""
                                                }`}
                                                renderValue={(selected) => selected.join(", ")}
                                                sx={{ width: "100%" }}
                                                MenuProps={{ autoFocus: false }}
                                            >
                                                <MenuItem
                                                    className="d-flex align-items-center"
                                                    value="all"
                                                    onClick={() =>
                                                        selectedSources.length === sources.length
                                                            ? toggleSourceSelection(null, "removeAll") // Remove All
                                                            : toggleSourceSelection(null, "selectAll") // Select All
                                                    }
                                                    sx={{
                                                        backgroundColor: `${selectedSources.length === sources.length ? "#f5f5f5" : "inherit"} !important`,
                                                        "&:hover": {
                                                            backgroundColor: "#e0e0e0 !important",
                                                        },
                                                    }}
                                                    disabled={selectedQuickFilters.length > 0 || !isDataLoaded}
                                                >
                                                    <Checkbox 
                                                        checked={selectedSources.length === sources.length} 
                                                        disableRipple
                                                    />
                                                    <span className="text-truncate ml-1 text-sm mt-1">
                                                        Select All
                                                    </span>
                                                </MenuItem>
                                                {sourceGroupsArray.map(({ group, sources: groupSources }) => {
                                                    const allSelected = groupSources.every(({ source }) => selectedSources.includes(source));
                                                    const someSelected = groupSources.some(({ source }) => selectedSources.includes(source));

                                                    const handleGroupCheckboxChange = (checked) => {
                                                        if (checked) {
                                                            // Select all sources in the group
                                                            setSelectedSources((prev) => [
                                                                ...prev,
                                                                ...groupSources
                                                                    .map(({ source }) => source)
                                                                    .filter((source) => !prev.includes(source)),
                                                            ]);
                                                        } else {
                                                            // Deselect all sources in the group
                                                            setSelectedSources((prev) =>
                                                                prev.filter((source) => !groupSources.some(({ source: gSource }) => gSource === source))
                                                            );
                                                        }
                                                    };

                                                    return (
                                                        <Accordion
                                                            key={group}
                                                            sx={{
                                                                boxShadow: "none",
                                                                "&:before": { display: "none" },
                                                            }}
                                                            disableGutters
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls={`${group}-content`}
                                                                id={`${group}-header`}
                                                                className="bg-light fw-bold fs-6 accordion-summary"
                                                                classes={{
                                                                    content: "accordion-summary-content",
                                                                }}
                                                            >
                                                                <Checkbox
                                                                    checked={allSelected}
                                                                    indeterminate={!allSelected && someSelected}
                                                                    onChange={(e) => handleGroupCheckboxChange(e.target.checked)}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                />
                                                                <span className="text-truncate ml-1 text-sm pt-2">
                                                                    {group}
                                                                </span>
                                                            </AccordionSummary>
                                                            <AccordionDetails className="p-2">
                                                                {groupSources.map(({ source, type }) => (
                                                                    <MenuItem
                                                                        key={source}
                                                                        value={source}
                                                                        disabled={!colorCoding[source.toLowerCase()]}
                                                                        onClick={() => {
                                                                            setSelectedSources((prev) =>
                                                                                prev.includes(source)
                                                                                    ? prev.filter((s) => s !== source) // Remove source
                                                                                    : [...prev, source] // Add source
                                                                            );
                                                                        }}
                                                                        className="d-flex align-items-center"
                                                                    >
                                                                        <Checkbox
                                                                            checked={selectedSources.includes(source)}
                                                                            tabIndex={-1}
                                                                            disableRipple
                                                                        />
                                                                        <span
                                                                            className={`badge pl-2 pr-1 text-xs mr-2 ml-1`}
                                                                            style={{
                                                                                backgroundColor:
                                                                                    colorCoding[source.toLowerCase()]?.hex || "#ccc",
                                                                            }}
                                                                        >
                                                                            &nbsp;
                                                                        </span>
                                                                        <span className="text-truncate text-sm mt-1">
                                                                            {sourceMapping[source.toLowerCase()] || source}
                                                                            {type === "Event" && " Events"}
                                                                            {type === "Release" && " Releases"}
                                                                            {source.length < 4 && !["RMA", "RFC"].includes(source)  ? ` (${source})` : ""}
                                                                        </span>
                                                                    </MenuItem>
                                                                ))}
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    );
                                                })}
                                            </Select>
                                        )}
                                    </FormControl>
                                    </div>
                                </div>
                            </AppBar >
                    <div className="main px-4 py-4">
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <div className="">
                                <div className="d-flex align-items-start justify-content-between">
                                    <div style={{ maxWidth: "67vw" }}> {selectedService && (
                                        <div className="d-flex align-items-center">
                                            <FilterAlt className="mr-2 text-secondary" />
                                            {[...availableFilters.filter(f => f.isMandatory), ...selectedFilters].map(({ key, label }) => (
                                                <FilterSelect
                                                    key={key}
                                                    label={label}
                                                    options={
                                                        key === "service" ? filterServiceObj :
                                                        key === "status" ? statusList :
                                                        key === "category" ? categoryList :
                                                        key === "environment" ? envList :
                                                        key === "tier" ? tierList :
                                                        key === "impact" ? impactList : []
                                                    }
                                                    selectedValues={
                                                        key === "service" ? selectedService :
                                                        key === "status" ? selectedStatus :
                                                        key === "category" ? selectedCategory :
                                                        key === "environment" ? selectedEnv :
                                                        key === "tier" ? selectedTier :
                                                        key === "impact" ? selectedImpact : []
                                                    }
                                                    onChange={
                                                        key === "service" ? handleServiceChange :
                                                        key === "status" ? handleStatusChange :
                                                        key === "category" ? handleCategoryChange :
                                                        key === "environment" ? handleEnvChange :
                                                        key === "tier" ? handleTierChange :
                                                        key === "impact" ? handleImpactChange : () => {}
                                                    }
                                                    onRemove={() => {
                                                        if (key === "service") removeSelectedService();
                                                        if (key === "status") removeSelectedStatus();
                                                        if (key === "category") removeSelectedCategory();
                                                        if (key === "environment") removeSelectedEnv();
                                                        if (key === "tier") removeSelectedTier();
                                                        if (key === "impact") removeSelectedImpact();
                                                    }}
                                                    disabled={selectedQuickFilters.length > 0 || !isDataLoaded}
                                                />
                                            ))}
                                            <div className="filter-container">
                                                <div className="d-flex align-items-center">
                                                    <Tooltip title="Add Filter">
                                                        <span>
                                                        <IconButton
                                                            onClick={handleFilterClick}
                                                            disabled={!isDataLoaded}
                                                            className="filter-icon-button bg-transparent"
                                                            sx={{
                                                                border: `1.4px solid ${isDataLoaded ? "black" : "#DAD7DB"}`,
                                                                color: "black",
                                                                "&:hover": { background: "rgba(0, 0, 0, 0.1)" }
                                                            }}
                                                        >
                                                            <Add />
                                                        </IconButton>

                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        open={Boolean(anchorEl)}
                                                        onClose={() => setAnchorEl(null)}
                                                    >
                                                        {availableFilters.filter(filter => !filter.isMandatory).map(filter => (
                                                            <MenuItem 
                                                                key={filter.key} 
                                                                onClick={() => handleFilterToggle(filter)}
                                                                selected={filter.isVisible} // This ensures the selected state is applied
                                                                sx={{
                                                                    "&.Mui-selected": {
                                                                        backgroundColor: "rgba(0, 0, 0, 0.08)", // Similar to Select focus color
                                                                    }
                                                                }}
                                                            >
                                                                <Checkbox checked={filter.isVisible} />
                                                                <span className="text-truncate text-sm">{filter.label}</span>
                                                            </MenuItem>
                                                        ))}
                                                    </Menu>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    }
                                    </div>
                                    <div className="d-flex align-items-center">
                                        {
                                            loadString && (
                                                !isDataLoaded ? <div className="badge badge-primary d-flex align-items-center">
                                                    <p className="text-sm mb-0 ml-1">
                                                        Fetching {loadString in sourceMapping ? sourceMapping[loadString] : loadString} 
                                                            {
                                                                loadString in sourceMapping && sourceMapping[loadString] === 'On-Prem DB' 
                                                                ? ' User Events'
                                                                : loadString in sourceMapping && sourceMapping[loadString] === 'Venafi Certificates'
                                                                ? ' Expiry Events'
                                                                : eventTypes.includes(sourceMapping[loadString]) 
                                                                ? ' Events' 
                                                                : ' Releases'
                                                            }...
                                                    </p>
                                                    <CircularProgress className="mx-2 text-white" size="1rem" />
                                                </div> : <div className="badge badge-success text-sm d-flex align-items-center">{loadString}<Check className="ml-1 text-white" sx={{ fontSize: '1.2rem' }} /></div>
                                            )
                                        }
                                        <h6 className="mb-0 ml-3 mr-2 text-secondary text-sm">
                                            {isListView ? "List View" : "Calendar View"} :
                                        </h6>
                                        <div
                                            className="btn-group btn-group-sm"
                                            role="group"
                                            aria-label="Basic example"
                                        >
                                            <button
                                                type="button"
                                                className={`btn btn-sm btn-outline-secondary ${isListView ? "" : "active"
                                                    }`}
                                                onClick={() => toggleView(false)}
                                            >
                                                <CalendarMonth fontSize="small" />
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn btn-sm btn-outline-secondary ${isListView ? "active" : ""
                                                    }`}
                                                onClick={() => toggleView(true)}
                                            >
                                                <FormatListBulleted fontSize="small" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {
                                    (hasDependentServiceReleases || hasServiceComponentReleases) && <Alert severity="info" className="text-sm mt-3" onClose={() => { closeAlert() }}>
                                        Your preferences are currently not allowing to show some of the updates related to Service Component(s) /  Dependent Service(s) of selected Business Service(s). Please update your preference to see more related updates.
                                    </Alert>
                                }
                                <div className="min-h-list">
                                    {isListView ? (
                                        <>
                                            <TimelineView isDataLoaded={isDataLoaded} events={filtererdEvents}/>
                                            <ListView isDataLoaded={isDataLoaded} events={filtererdEvents} {...(releaseId ? { releaseId: usedReleaseId } : {})} />
                                        </>
                                    ) : (
                                        <CalendarView isDataLoaded={isDataLoaded} events={filtererdEvents} preference={preference} {...(releaseId ? { releaseId: usedReleaseId } : {})} />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <ToastContainer />
                    {
                        openTab && <UserPreference
                            open={isUserPreferenceOpen}
                            onClose={handleClosePreference}
                            preferences={preference}
                            isNewUser={isNewUser}
                            openTab={openTab}
                        />
                    }
                    </>
                    }
                </div>
            </div>
        </> : (
            preference && <UserPreference
                open={isUserPreferenceOpen}
                onClose={handleClosePreference}
                preferences={preference}
                isNewUser={isNewUser}
                openTab={openTab}
            />
        )
    );
};

export default MainView;
